import { inject, Injectable } from '@angular/core';
import { PublicBannerApiService } from '../api/services/public-banner-api.service';
import { catchError, map, Observable, of } from 'rxjs';
import { multimediaFromResponse } from '@web/shared/module/multimedia';
import { PublicBannerCollectionItem } from '../models/public-banner-collection-item';
import { CollectionRequestBuilder } from '@web/common';
import { BannerLocationType } from '../../shared/enums/banner-location-type';
import { Guid, isNotNil } from '@web/utils';

@Injectable({
  providedIn: 'root',
})
export class PublicBannerDataSourceService {
  private readonly bannerApi = inject(PublicBannerApiService);
  private readonly collectionRequestBuilder = inject(CollectionRequestBuilder);

  public fetchCollection(options: {
    type: BannerLocationType;
  }): Observable<PublicBannerCollectionItem[]> {
    const { type } = options;
    return this.bannerApi
      .fetchCollection({
        type,
        request: this.collectionRequestBuilder
          .disablePagination()
          .sorts((builder) => [builder.descendingFor('createdAt').build()])
          .build(),
        cacheable: true,
      })
      .pipe(
        map((response) =>
          response.items.map(
            (item) =>
              new PublicBannerCollectionItem({
                file: multimediaFromResponse(item.file),
                id: item.id,
                location: item.location,
                smallFile: isNotNil(item.smallFile)
                  ? multimediaFromResponse(item.smallFile)
                  : null,
                url: item.url,
              }),
          ),
        ),
        catchError(() => of([])),
      );
  }

  public registerRedirectById(id: Guid): Observable<void> {
    return this.bannerApi
      .registerRedirect({ id })
      .pipe(catchError(() => of(void 0)));
  }
}
